import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import { REPORTS } from './api.routes'
import {
  RoundsReportResponse,
  ReportsState,
  GetReportsPayload,
} from '../models'

import ActionTypes from '../constants'
import { ReportsActions } from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getRoundsReportsThunk = createAsyncThunk(
  ActionTypes.GET_ROUNDS,
  async (payload: GetReportsPayload, thunkAPI) => {
    try {
      const { xlsx, ...queries } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(ReportsActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.requestParams = {
        method: 'GET',
        endpoint:
          process.env.REACT_APP_STAGE === 'prod'
            ? REPORTS.FIND_PROD
            : REPORTS.FIND_DEV,
        externalServerURL:
          process.env && process.env.REACT_APP_SERVER_REPORTS_API,
        queries: jsonToQueryString(queries),
      }

      const response: RoundsReportResponse = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token || '',
        process.env.REACT_APP_TOKEN_REPORTS,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getRoundsReportsExtraReducer = (
  builder: ActionReducerMapBuilder<ReportsState>,
) => {
  builder.addCase(
    getRoundsReportsThunk.fulfilled,
    (state, { payload, meta }) => {
      const { xlsx } = meta?.arg

      state.isLoading = false
      state.roundsReports = xlsx ? state.roundsReports : payload.docs
      state.roundsPagination = xlsx
        ? state.roundsPagination
        : {
            ...state.roundsPagination,
            total: payload.total,
            pages: payload.pages,
            page: payload.page,
            limit: payload.limit,
          }
    },
  )
}

export default getRoundsReportsExtraReducer
